// Mount the platform-provided login route at /login.

import { loginRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login')(loginRoute)
